jQuery(document).ready(function($) {

    //See more Description toggle
    $('.single-product-layout-1 .product-description-wrapper .seemore').click(function(){
        $(this).siblings('.sur-description').toggleClass('active');
        $(this).siblings('.bread-description').toggleClass('de-active');
        $(this).children('.icon-dropdown').toggleClass('de-active');
        $(this).children('.icon-dropdown-up').toggleClass('active');
    });

    //Accordion toggle
    $('.single-product-layout-1 .accordion-header').click(function(){
        $(this).siblings('.accordion-content').slideToggle('fast');
        $(this).children('.icon-down').toggleClass('de-active');
        $(this).children('.icon-up').toggleClass('de-active');
    });
    
    $('.variant-picker .product-form-input input').click(function(){
        $(this).parent().addClass('checked');
        $(this).parent().siblings().removeClass('checked');

    });

    //Change color for rate star and value for rate star - customer review/comment
    $('.single-product .detail-info-product .product-comment .rate .star').click(function(){
        var star_class = parseInt($(this).attr('class').split(' ')[0]);
        var star_parent = $(this).parent();
        if(star_class > 1){
            for(var i = 0; i <= star_class; i++){
                star_parent.children(`.${i}`).children('i').css('color','#F5C34B');
            }
        }
        for(var j = star_class + 1; j <= 5; j++){
            star_parent.children(`.${j}`).children('i').css('color','#F3F5F6');
        }
        star_parent.children('input').attr('value', star_class + '-star');
    });

    //Click event for ask a question in function bar
    $('.single-product .product-function-container .product-function-wrapper .qna-wrapper').click(function(){
        var qna_content = $('.single-product .detail-info-product .accordion-wrapper .accordion-6 .accordion-content');
        qna_content.slideDown('fast');
        qna_content.siblings('.accordion-header').children('.icon-down').addClass('de-active');
        qna_content.siblings('.accordion-header').children('.icon-up').removeClass('de-active');
    });
    //Click event for return policy under function bar
    $('.single-product .product-function-container .policy-wrapper .return-content').click(function(){
        var ret_content = $('.single-product .detail-info-product .accordion-wrapper .accordion-4 .accordion-content');
        ret_content.slideDown('fast');
        ret_content.siblings('.accordion-header').children('.icon-down').addClass('de-active');
        ret_content.siblings('.accordion-header').children('.icon-up').removeClass('de-active');
    });

    //Click event for sharing button in function bar
    $('.single-product .product-function-container .product-function-wrapper .share-wrapper').click(function(){
        $(this).children('ul').toggleClass('active');
    });

    //Change quantity of input - main product form
    $('body').on('click', '.single-product .product-function-container .product-form-button .quantity .minus', function() {
        var $input = $(this).siblings('input');
        var count = parseInt($input.val()) - 1;
        count = count < 1 ? 1 : count;
        $input.val(count);
        $input.change();
        return false;
    });
    $('body').on('click', '.single-product .product-function-container .product-form-button .quantity .plus', function() {
        var $input = $(this).siblings('input');
        $input.val(parseInt($input.val()) + 1);
        $input.change();
        return false;
    });

    $('body').on('change', '.single-product .product-function-container .product-form-button .quantity input', function(){
        var key = $(this).parent().parent().siblings('#product-id').val();
        var count;
        var number_input = $(this).val();
        if(number_input > cartItemMaxQuantities[key]){
            count = cartItemMaxQuantities[key];
            $('.check-stock-quantity').addClass('active-ck-quantity-single-product');
            var myTimeout = setTimeout(checkInventoryQuantitySingleproduct, 2500);
        }
        else{
            count = number_input > 0 ? number_input : 1;
        }
        $(this).val(count);
    });

    //Change quantity of input - groupbuy form 2
    $('body').on('click', '.single-product .group-buy-container-2 .quantity .minus', function() {
        var $input = $(this).siblings('input');
        var isdisabled = $input.prop('disabled');
        if(isdisabled == false){
            var count = parseInt($input.val()) - 1;
            count = count < 0 ? 0 : count;
            $input.val(count);
            $input.change();
            return false;
        }
    });
    $('body').on('click', '.single-product .group-buy-container-2 .quantity .plus', function() {
        var $input = $(this).siblings('input');
        var isdisabled = $input.prop('disabled');
        if(isdisabled == false){
            $input.val(parseInt($input.val()) + 1);
            $input.change();
            return false;
        }
    });
    $('body').on('change', '.single-product .group-buy-container-2 .quantity input', function(){
        var key = $(this).parent().siblings('input').attr('data-variant');
        var count;
        var number_input = $(this).val();
        if(number_input > cartItemMaxQuantities[key]){
            count = cartItemMaxQuantities[key];
            $('.check-stock-quantity').addClass('active-ck-quantity-single-product');
            var myTimeout = setTimeout(checkInventoryQuantitySingleproduct, 2500);
        }
        else{
            count = number_input >= 0 ? number_input : 0;
        }
        $(this).val(count);
        $(this).parent().siblings('input').val(count);
    });

    //Change input tag on products - group buy 1
    $('body').on('change', '.single-product .group-buy-container-1 .products-container .checkbox-options input', function(){
        var variant_id = $(this).attr('data-variant_id');
        var variant_img = '.single-product .group-buy-container-1 .products-container .image-addbutton .variant-img-' + variant_id;
        if($(this).is(':checked')){
            $(variant_img).addClass('selected');
        }
        else{
            $(variant_img).removeClass('selected');
        }
        var input_checked = $('.single-product .group-buy-container-1 .products-container .checkbox-options input:checked');
        var total_price = 0;
        input_checked.each(function(){
            var item_price = $(this).attr('data-price');
            total_price = total_price + Number(item_price);
        });
        var total_price_div =  $('.single-product .group-buy-container-1 .products-container .image-addbutton .total-price');
        total_price_div.text(Shopify.formatMoney(total_price, money_format));
    });

    //Add to cart products - groupbuy 1
    $('.single-product .group-buy-container-1 .products-container .image-addbutton button').click(function(e){
        e.preventDefault();
        var formData = {
            'items': []
        };
        var input_checked = $('.single-product .group-buy-container-1 .products-container .checkbox-options input:checked');
        input_checked.each(function(){
            var variant_id = $(this).attr('data-variant_id');
            var item = {
                'id': variant_id,
                'quantity': 1
            };
            formData['items'].push(item);
        });
        if(formData['items'].length > 0){
            $(this).addClass('loading');
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                changeThemeWhenAddtoCartSuccess(123);
                $(this).removeClass('loading');
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        } 
    });
});
//Click event for photoswipe
(function($) {
    var container = [];
    // Loop over gallery items and push it to the array
    var div_thumb = '.single-product .detail-info-product .image-wrapper .thumbs'
    $(div_thumb).find('li').each(function() {
        var $link = $(this).find('img');
        var item = {
            src: $link.attr('src'),
            w: $link.attr('data-width'),
            h: $link.attr('data-height')
        };
        container.push(item);
    });

    // Define click event on gallery item
    var expand_button = '.single-product .detail-info-product .image-wrapper .image-display .expand'
    $(expand_button).click(function() {
        // Define object and gallery options
        var img_selected = $('.single-product .detail-info-product .image-wrapper .thumbs .selected');
        var thumbs = '.single-product .detail-info-product .image-wrapper .thumbs li';
        var img_index = $(thumbs).index(img_selected);
        var $pswp = $('.pswp')[0],
        options = {
            index: img_index,
            history: false,
            focus: false,
            showAnimationDuration: 0,
            hideAnimationDuration: 0,
            bgOpacity: 0.85,
            showHideOpacity: true
        };

        // // Initialize PhotoSwipe
        var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
        gallery.init();
    });
}(jQuery));